import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import CartRepository from "../../../repository/CartRepository";
import produceClone from "../../../helper/produceClone";
import System from "src/helper/system";
import AuthConfig from "@system/config/auth";


const CART_COUNT_ss = "CART_COUNT_" + AuthConfig.getAccountNumber() + "_" + System.auth('salesOrg') + "_" + AuthConfig.getAuthSBoat()

const initialState = {
    CART_COUNT: sessionStorage.getItem(CART_COUNT_ss) ? sessionStorage.getItem(CART_COUNT_ss) : 0,
    CART_DATA: {},
    CART_READY_TO_GO_FOR_CHECKOUT: false,
    CART_DATA_OBJECT: {},
    CART_LOADER_DATA_OBJECT: {},
    CART_SHIPPING_ADDRESS_ID: false,
    WEB_ORDER_ID: false,
    CART_PRODUCT_DATA: {},
    CART_PRODUCT_INVENTORY_DATA: {},
    CART_PRODUCT_PRICING_DATA: {},
    CART_BEFORE_TO_SEND_SERVER: {},
    CART_PRICE_BEFORE_TO_SEND_SERVER: {},
    CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER: {},
    // CHECKOUT_DATA: urlStorage.getItem('ot'),
    VAT_DATA: 0.00,
    MFR_CODE_LIST_SHIP_TO_VALIDATE: [],
    // CALCULATED_VAT_DATA: 0,
    // CART_SUBTOTAL: 0,
    SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE: 0,
    CART_DATA_ERROR: false,
    ADD_CART_DATA: false,
    QUOTE_CART_BLACKLISTED_ARR: []
};

export const addCartInBulk = createAsyncThunk('cart_addCartInBulk', async (params) => {
    return await new CartRepository().addCartInBulk(params)
});

export const getVatData = createAsyncThunk('cart_getVatData', async () => {
    return await new CartRepository().getVatData()
});

export const getMrfCodeToValidateToShip = createAsyncThunk('cart_getMrfCodeToValidateToShip', async (countryCode) => {
    return await new CartRepository().getMrfCodeToValidateToShip(countryCode)
});
// export const getCalculatedVatData = createAsyncThunk('cart_getCalculatedVatData', async (cart_data) => {
//     return await new CartRepository().vatCalculationCount(cart_data.cart_data, cart_data.vat_data)
// });

// export const getCartSubTotal = createAsyncThunk('cart_getCartSubTotal', async (cart_data) => {
//     return await new CartRepository().getCartSubTotal(cart_data)
// });
// export const getQuoteCartSubTotal = createAsyncThunk('cart_getCartSubTotal', async (cart_data) => {
//     return await new CartRepository().getQuoteCartSubTotal(cart_data)
// });
// export const getQuoteCalculatedVatData = createAsyncThunk('cart_getCalculatedVatData', async (cart_data) => {
//     return await new CartRepository().vatQuoteCalculationCount(cart_data.cart_data, cart_data.vat_data)
// });
export const checkQuoteCartItemBlackListed = createAsyncThunk('cart_checkQuoteCartItemBlackListed', async (params) => {
    return await new CartRepository().checkItemsForBlackListedCountry(params);
});

const slice = createSlice({
    name: "cart",
    initialState: initialState,
    reducers: {
        SET_CART_COUNT: {
            reducer: (state, action) => {
                state.CART_COUNT = action.payload.CART_COUNT
                sessionStorage.setItem(CART_COUNT_ss, action.payload.CART_COUNT)
            },
        },
        SET_CART_READY_TO_GO_FOR_CHECKOUT: {
            reducer: (state, action) => {
                state.CART_READY_TO_GO_FOR_CHECKOUT = action.payload.status
            },
        },
        SET_CLEAR_ALL_CART: {
            reducer: (state) => {
                state.CART_DATA = initialState.CART_DATA;
                state.CART_COUNT = initialState.CART_COUNT;
                state.CART_READY_TO_GO_FOR_CHECKOUT = initialState.CART_READY_TO_GO_FOR_CHECKOUT;
                state.CART_DATA_OBJECT = initialState.CART_DATA_OBJECT;
                state.CART_SHIPPING_ADDRESS_ID = initialState.CART_SHIPPING_ADDRESS_ID;
                state.CART_PRODUCT_DATA = initialState.CART_PRODUCT_DATA;
                state.CART_PRODUCT_INVENTORY_DATA = initialState.CART_PRODUCT_INVENTORY_DATA;
                state.CART_PRODUCT_PRICING_DATA = initialState.CART_PRODUCT_PRICING_DATA;
                
                sessionStorage.removeItem(CART_COUNT_ss)
                return state;
            },
        },
        SET_CART_DATA: {
            reducer: (state, action) => {
                state.CART_DATA = action.payload.CART_DATA;
                state.CART_COUNT = action.payload.CART_DATA.length;
                sessionStorage.setItem(CART_COUNT_ss, action.payload.CART_DATA.length)
                state.CART_DATA_OBJECT = {}
                if (action.payload.CART_DATA !== undefined && action.payload.CART_DATA.length > 0) {
                    action.payload.CART_DATA.map((v) => {
                        state.CART_DATA_OBJECT[v.ERPPartNumber] = v;
                        state.CART_DATA_OBJECT[v.ItemNumber] = v;
                    })
                }
            },
        },
        SET_CART_DATA_OBJECT: {
            reducer: (state, action) => {
                if (action.payload == undefined) {
                    if (state.CART_DATA !== undefined && state.CART_DATA.length > 0) {
                        state.CART_DATA.map((v) => {
                            state.CART_DATA_OBJECT[v.ERPPartNumber] = { ...v };
                            state.CART_DATA_OBJECT[v.ItemNumber] = { ...v };
                        })
                    } else {
                        state.CART_DATA_OBJECT = {}
                    }
                } else {
                    state.CART_DATA_OBJECT[action.payload.ERPPartNumber] = action.payload;
                    state.CART_DATA_OBJECT[action.payload.ItemNumber] = action.payload;
                }

            },
        },
        SET_CART_LOADER_DATA_OBJECT: {
            reducer: (state, action) => {
                if (action?.payload) {
                    state.CART_LOADER_DATA_OBJECT = {}
                    state.CART_LOADER_DATA_OBJECT[action.payload.ItemNumber] = { ...action.payload };
                } else {
                    state.CART_LOADER_DATA_OBJECT = {}
                }
            },
        },
        SET_CART_SHIPPING_ADDRESS_ID: {
            reducer: (state, action) => {
                state.CART_SHIPPING_ADDRESS_ID = action.payload.CART_SHIPPING_ADDRESS_ID
            },
        },
        SET_CART_WEB_ORDER_ID: {
            reducer: (state, action) => {
                state.WEB_ORDER_ID = action.payload.WEB_ORDER_ID
            },
        },
        SET_CART_PRODUCT_DATA: {
            reducer: (state, action) => {
                state.CART_PRODUCT_DATA = action.payload.CART_PRODUCT_DATA
                const allowed = ['ROHSCompliantCodeValue', 'ROHSCompliantCode', 'NCNRFlag', 'PackagingTypeCode', 'WebOnlyFlag', 'NPIFlag', 'ObsoleteFlag', 'TopSellerFlag', 'EndOfLifeFlag', 'ERPPartNumber', 'ERPPartNumberModified'];

                let tempCopy = { ...action.payload.CART_PRODUCT_DATA }

                Object.keys(tempCopy).forEach((item, index) => {
                    let test = { ...tempCopy[item] }
                    Object.keys(test)
                        .filter(key => !allowed.includes(key))
                        .forEach(key => {
                            delete test[key]
                        })
                    tempCopy[item] = test
                })
                localStorage.setItem("cartProductData", JSON.stringify(tempCopy))
            },
        },
        SET_CART_PRODUCT_INVENTORY_DATA: {
            reducer: (state, action) => {
                state.CART_PRODUCT_INVENTORY_DATA = action.payload.CART_PRODUCT_INVENTORY_DATA
                localStorage.setItem("cartProductInventoryData", JSON.stringify(action.payload.CART_PRODUCT_INVENTORY_DATA))
            },
        },
        SET_CART_PRODUCT_PRICING_DATA: {
            reducer: (state, action) => {
                console.log(action.payload.CART_PRODUCT_PRICING_DATA)
                state.CART_PRODUCT_PRICING_DATA = action.payload.CART_PRODUCT_PRICING_DATA
            },
        },
        SET_CART_PRODUCT_PRICING_DATA_BY_ERP_PART_NUMBER: {
            reducer: (state, action) => {
                if (state.CART_PRODUCT_PRICING_DATA[action.payload.CART_PRODUCT_PRICING_DATA.ERPPartNumber] !== undefined) {
                    console.log(action.payload.CART_PRODUCT_PRICING_DATA.ERPPartNumber)
                    state.CART_PRODUCT_PRICING_DATA[action.payload.CART_PRODUCT_PRICING_DATA.ERPPartNumber] = action.payload.CART_PRODUCT_PRICING_DATA.single_pricing_array;
                }
                return state;
            },
        },
        /**
         * Ticket #  : 8451
         * Change #  : Inventory we're fetching from CART_BEFORE_TO_SEND_SERVER that's why removed
         * Change by : Pankaj
         * Date      : 03 Feb 2023
         * Note      : Test in all ways and than uncomment / remove
         */
        // REMOVE_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
        //     reducer: (state, action) => {
        //         if (state.CART_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ERPPartNumber] !== undefined) {
        //             delete state.CART_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ERPPartNumber]
        //         }
        //     },
        // },
        SET_INVALID_STATUS_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                let a = produceClone(action.payload.CART_DATA);
                if (state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] !== undefined) {
                    state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] = a
                }
            },
        },
        SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                let a = action.payload.CART_DATA;
                if (state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] !== undefined) {
                    let s_h = produceClone(state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber]);
                    s_h.obsolete_EOL_invalidate_message_active = a.obsolete_EOL_invalidate_message_active;
                    state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] = s_h
                }
            },
        },
        SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                let a = produceClone(action.payload.CART_DATA);
                if (a.quantityAddToCart > 0) {
                    state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] = a
                } else {
                    if (state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber] !== undefined &&
                        a.quantityAddToCart < 1) {
                        delete state.CART_BEFORE_TO_SEND_SERVER[a.ItemNumber]
                    }
                }
            },
        },
        SET_CART_DATA_QUANTITY: {
            reducer: (state, action) => {
                state.CART_DATA[action.payload.index].quantity = action.payload.quantity;
            },
        },
        SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                /*Payload will have very minimal data - use CART_BEFORE_TO_SEND_SERVER
                this data may merge with CART_BEFORE_TO_SEND_SERVER in future before sending to server
                * */
                if (action.payload.CART_DATA.unitPrice !== undefined) {
                    state.CART_PRICE_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber] = action.payload.CART_DATA
                }
            },
        },
        REMOVE_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                /*Payload will have very minimal data - use CART_BEFORE_TO_SEND_SERVER
                this data may merge with CART_BEFORE_TO_SEND_SERVER in future before sending to server
                * */
                delete state.CART_PRICE_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber]
            },
        },
        SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {
                /*Payload will have very minimal data - use CART_BEFORE_TO_SEND_SERVER
               this data may merge with CART_BEFORE_TO_SEND_SERVER in future before sending to server
               EXAMPLE:
               CART_DATA: {
                   ERPPartNumber: ERPPartNumber,
                   CUSTOMER_PART_NUMBER: CUSTOMER_PART_NUMBER
               },
               * */
                if (action.payload.CART_DATA.CUSTOMER_PART_NUMBER !== undefined) {
                    if (action.payload.CART_DATA.CUSTOMER_PART_NUMBER === 'false' || action.payload.CART_DATA.CUSTOMER_PART_NUMBER === false) {
                        if (state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber]) {
                            delete state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber];
                        }
                    } else {
                        state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber] = action.payload.CART_DATA
                    }
                }
            },
        },
        SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT: {
            reducer: (state, action) => {

                /**DT - 3 March - Bug 9369: My Cart: Manually add option is showing default selected with entered cpn on re-adding the same part in the cart once deleted the part */
                // state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER = {};
                /**DT - 28 APR - Bug 10877: CPN changed when adding to cart */
                action.payload.CART_DATA.map((v) => {
                    state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[v.ItemNumber] = v
                });
            },
        },
        // SET_CHECKOUT_DATA: {
        //     reducer: (state, action) => {
        //         state.CHECKOUT_DATA = action.payload; // Nood To Delete for CHECKOUT_DATA
        //         urlStorage.setItem('ot', state.CHECKOUT_DATA);
        //     },
        // },
        SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE: {
            reducer: (state, action) => {
                state.SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE = action.payload;
            },
        },

        SET_CART_DATA_ERROR: {
            reducer: (state, action) => {
                state.CART_DATA_ERROR = action.payload;
            },
        },
        SET_ADD_CART_DATA: {
            reducer: (state, action) => {
                state.ADD_CART_DATA = action.payload;
            },
        },
        REMOVE_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER: {
            reducer: (state, action) => {
                if (state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber]) {
                    delete state.CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[action.payload.CART_DATA.ItemNumber];
                }
            },
        },
    },
    extraReducers: {
        [getVatData.fulfilled]: (state, { payload }) => {
            state.VAT_DATA = payload;
            return state;
        },
        [getVatData.rejected]: (state, { payload }) => {
        },
        [getMrfCodeToValidateToShip.fulfilled]: (state, { payload }) => {
            state.MFR_CODE_LIST_SHIP_TO_VALIDATE = payload.data;
            return state;
        },
        // [getCalculatedVatData.fulfilled]: (state, { payload }) => {
        //     state.CALCULATED_VAT_DATA = payload;
        //     return state;
        // },
        // [getCalculatedVatData.rejected]: (state, { payload }) => {
        // },
        // [getCartSubTotal.fulfilled]: (state, { payload }) => {
        //     state.CART_SUBTOTAL = payload;
        //     return state;
        // },
        // [getCartSubTotal.rejected]: (state, { payload }) => {
        // },
        // [getQuoteCalculatedVatData.fulfilled]: (state, { payload }) => {
        //     state.CALCULATED_VAT_DATA = payload;
        //     return state;
        // },
        // [getQuoteCalculatedVatData.rejected]: (state, { payload }) => {
        // },
        // [getQuoteCartSubTotal.fulfilled]: (state, { payload }) => {
        //     state.CART_SUBTOTAL = payload;
        //     return state;
        // },
        // [getQuoteCartSubTotal.rejected]: (state, { payload }) => {

        // },
        [checkQuoteCartItemBlackListed.fulfilled]: (state, { payload }) => {
            state.QUOTE_CART_BLACKLISTED_ARR = payload?.data?.length > 0 ? payload?.data : [];
            return state;
        },
        [checkQuoteCartItemBlackListed.rejected]: (state, { payload }) => {
        },
    },
});


export let {
    SET_CART_COUNT,
    SET_CART_READY_TO_GO_FOR_CHECKOUT,
    SET_CLEAR_ALL_CART,
    SET_CART_PRODUCT_DATA,
    SET_CART_DATA,
    SET_CART_DATA_OBJECT,
    SET_CART_LOADER_DATA_OBJECT,
    SET_CART_SHIPPING_ADDRESS_ID,
    SET_CART_WEB_ORDER_ID,
    SET_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_DATA_QUANTITY,
    SET_INVALID_STATUS_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    REMOVE_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    REMOVE_CART_PRICE_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_BULK_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT,
    SET_CART_PRODUCT_PRICING_DATA_BY_ERP_PART_NUMBER,
    SET_CART_PRODUCT_INVENTORY_DATA,
    SET_CART_PRODUCT_PRICING_DATA,
    // SET_CHECKOUT_DATA,
    SET_SELECTED_SHIPPING_ADDRESS_COUNTRY_CODE,
    SET_CART_DATA_ERROR,
    SET_ADD_CART_DATA,
    REMOVE_CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER
} = slice.actions;

export default slice.reducer;
